import { useCallback, useState } from "react";
import { VerificationStageStatus } from "@/features/operations/verifications/types.ts";
import type { VerificationStage } from "../types.ts";

export interface UseVerifySelectionReturn {
  selectedIds: number[];
  selectedOrderItemIds: number[];
  selectedStatuses: VerificationStageStatus[];
  selectingAll: boolean;
  selectionResetKey: number;
  setSelectingAll: (value: boolean) => void;
  handleSelect: (params: { selectedRows: VerificationStage[] }) => void;
  clearSelection: () => void;
}

export const useVerifySelection = (): UseVerifySelectionReturn => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const [selectedOrderItemIds, setSelectedOrderItemIds] = useState<number[]>(
    [],
  );
  const [selectedStatuses, setSelectedStatuses] = useState<
    VerificationStageStatus[]
  >([]);
  const [selectingAll, setSelectingAll] = useState<boolean>(false);
  const [selectionResetKey, setSelectionResetKey] = useState(0);

  const handleSelect = useCallback(
    (params: { selectedRows: VerificationStage[] }) => {
      const ids: number[] = [];
      const orderItemIds: number[] = [];
      const statuses: VerificationStageStatus[] = [];

      params.selectedRows.forEach((row) => {
        if (row.verificationStageId) ids.push(row.verificationStageId);
        orderItemIds.push(row.orderItemId);
        if (row.verificationStageStatus !== undefined) {
          statuses.push(row.verificationStageStatus);
        }
      });

      setSelectedIds(ids);
      setSelectedOrderItemIds(orderItemIds);
      setSelectedStatuses(statuses);
      setSelectingAll(false);
    },
    [],
  );

  const clearSelection = useCallback(() => {
    setSelectedIds([]);
    setSelectedOrderItemIds([]);
    setSelectedStatuses([]);
    setSelectingAll(false);
    setSelectionResetKey((prev) => prev + 1);
  }, []);

  return {
    selectedIds,
    selectedOrderItemIds,
    selectedStatuses,
    selectingAll,
    selectionResetKey,
    setSelectingAll,
    handleSelect,
    clearSelection,
  };
};
